import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import Page from '../../components/Page/Page';

const Error401 = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page
      title="Error 401"
      style={{
        padding: '24px',
        paddingTop: '10vh',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center'
      }}
    >
      <Typography align="center" variant={mobileDevice ? 'h4' : 'h1'}>
        401: We are sorry but we are not able to authenticate you.
      </Typography>
      <Typography align="center" variant="subtitle2">
        You either tried some shady route or you came here by mistake. Whichever
        it is, try using the navigation
      </Typography>
      <div
        style={{
          marginTop: '48px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <img
          alt="Under development"
          style={{ maxWidth: '100%', width: 560, maxHeight: 300, height: 'auto' }}
          src="/images/undraw_authentication_fsn5.svg"
        />
      </div>
      <div
        style={{
          marginTop: '48px',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          variant="outlined"
        >
          Back to home
        </Button>
      </div>
    </Page>
  );
};

export default Error401;
